import RestAPI from "components/Common/restApi";

export default class ActivityFeedModel {

    getActivityItems(page, searchQuery, successCallback, failureCallback) {
        RestAPI.get(
            `/pro/activity_feed?page=${page}&search_query=${searchQuery}`)
            .then((response) => {
              console.log(
                `server response ${response.data.activity_items.map((item) => {
                  return item.id;
                })}`
              );
              successCallback(response.data.activity_items);
            })
            .catch((error) => {
              console.log(error.response.request);
              console.log(error.response.request.statusText);
              failureCallback(error.response.request.statusText);
            });
    }
}